export class CrediExperto {
  constructor(featureToggleClient) {
    this.FEATURE_TOGGLE_NAME = 'show-credi-expert';
    this.featureToogleClient = featureToggleClient;
  }

  async showCrediExperto() {
    const crediExpertConfig = await this.featureToogleClient(this.FEATURE_TOGGLE_NAME);
    if (!crediExpertConfig.isActive) {
      return false;
    }
    return true;
  }
}
